import { useContext } from "react";
import { Navigate, useParams } from "react-router-dom";
import { PATH_INFO } from "../utils/helper";
import { UserContext } from "../../context/userContext";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuth } = useContext(UserContext)
  const { sampleId } = useParams()

  if (isAuth === undefined) {
    return <div>loading...</div>
  }

  if (!isAuth && !sampleId) {
    return <Navigate to={PATH_INFO.LOGIN.PATH} replace />
  }

  return <>{children}</>
}